import axios from 'axios';

import store from '../store';
import { invalidateUser } from '../reducers/userReducer';
import * as overlayingModal from '../reducers/overlayingModalReducer';
import * as modal from '../reducers/modalReducer';
import { rootPageUri } from '../config/uri';
import { kioskModeType } from '../config/const';
import { pushWithQueryParams } from './uri';

axios.interceptors.response.use((response) => response,
  (error) => {
    // Do something with response error
    if (error.message.includes("Cancelled previous request")) {
      return;
    }

    if (!!!error || !!!error.response || error.response.status === 404 || error.response.status === 500) {
      store.dispatch(overlayingModal.showModal({
        modalType: 'SOMETHING_WRONG_MODAL',
        modalProps: {}
      }));
    }

    const state = store.getState();

    if (state.view.kioskMode === kioskModeType.PAYMENT_KIOSK ||
      state.view.kioskMode === kioskModeType.DPOS) {
      console.error('Kiosk token expired.');
      store.dispatch(pushWithQueryParams(rootPageUri));
      store.dispatch(invalidateUser());
      store.dispatch(modal.openModal({
        modalType: 'KIOSK_LOGIN_FORM',
        modalProps: {}
      }));
      return;
    }

    if (error.response.status === 401) {
      store.dispatch(pushWithQueryParams(rootPageUri));
      store.dispatch(invalidateUser());
      store.dispatch(modal.openModal({
        modalType: 'LOGIN_FORM',
        modalProps: {
          raisedClass: 'raise'
        }
      }));
    }

    return Promise.reject(error);
  });

export default axios;



// WEBPACK FOOTER //
// ./src/services/axios.js